// src/hooks/useLiveRefresh.js
// --- UPDATE (FlowSense widgets) — NEW FILE ---------------------------------------------------------
// Re-runs `refresh` when any of the given websocket events arrive, debounced so a burst of events
// causes one refetch. `accept(body, eventType)` can drop events that do not change the widget
// (body is the inner payload — listeners receive { type, payload }).
//
//   useLiveRefresh(['work_order_events'], () => fetchData(false), { enabled: !externalData });
// --- END UPDATE -------------------------------------------------------------------------------------
import { useEffect, useRef, useState } from 'react';
import webSocketService from '../services/websocketService';

const bodyOf = (msg) => (msg && typeof msg === 'object' && msg.payload && typeof msg.payload === 'object' ? msg.payload : (msg || {}));

export default function useLiveRefresh(events, refresh, { enabled = true, delay = 4000, accept } = {}) {
  const refreshRef = useRef(refresh);
  const acceptRef = useRef(accept);
  const [lastEventAt, setLastEventAt] = useState(null);
  useEffect(() => { refreshRef.current = refresh; acceptRef.current = accept; });
  const key = (events || []).join('|');

  useEffect(() => {
    if (!enabled || !key) return undefined;
    let timer = null;
    const offs = key.split('|').map((type) => {
      const handler = (msg) => {
        const body = bodyOf(msg);
        if (acceptRef.current && !acceptRef.current(body, type)) return;
        setLastEventAt(new Date());
        clearTimeout(timer);
        timer = setTimeout(() => { try { refreshRef.current?.(); } catch (e) { console.error('[useLiveRefresh]', e); } }, delay);
      };
      const off = webSocketService?.subscribe?.(type, handler);
      return () => (typeof off === 'function' ? off() : webSocketService?.unsubscribe?.(type, handler));
    });
    return () => { clearTimeout(timer); offs.forEach((off) => off()); };
  }, [key, enabled, delay]);

  return { lastEventAt };
}
